import React from 'react';
export function IntroSection() {
  return <div className="grid md:grid-cols-2 gap-12 items-center mb-20" data-id="element-3831">
      <div data-id="element-3832">
        <p className="text-lg text-gray-700 leading-relaxed mb-6" data-id="element-3833">
          Peak Machine Sales was recently named Michigan's exclusive distributor
          for{' '}
          <a href="https://spinnernorthamerica.com/" target="_blank" rel="noopener noreferrer" className="text-[#002d4d] font-bold underline hover:text-orange transition-colors" data-id="element-3834">
            SPINNER Machine Tools
          </a>
          .
        </p>
        <p className="text-lg text-gray-700 leading-relaxed" data-id="element-3835">
          Known for their high precision, SPINNER CNC machines are built in
          Germany with the quality and attention to detail you'd expect from a
          German machine tool and offering affordable, reliable, sub-micron
          machining accuracy for CNC milling, turning, & multitasking machines.
        </p>
      </div>
      <div className="aspect-video rounded-xl overflow-hidden shadow-xl" data-id="element-3836">
        <iframe src="https://www.youtube.com/embed/PU2YbshqCbw" title="SPINNER Machine Tools Video" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen className="w-full h-full" data-id="element-3837"></iframe>
      </div>
    </div>;
}